<ion-header>
  <ind-page-title [viewData]="newActivityPageTitle" (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
</ion-header>
<ion-content>
  <ion-list>
    <ind-section-header *ngIf="isMeetingPresentation" [viewData]='newActivityHeader'
      (onControlClick)='onPageTitleControlClick($event)'>
    </ind-section-header>
    <ion-item-group class="toolActivtiesList" [ngClass]="{'activity-create-disabled': activityCreationInProgress}">
      <ion-item *ngIf="NewActivitySource === 'MeetingPresentation'" (click)="setActiveView('MeetingPresentation')"
        [ngClass]="{'activity-create-pending': isCreatingActivity('MeetingPresentation')}">
        {{'CONTENT' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('MeetingPresentation')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('MeetingPresentation')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="item-with-category-select" *ngIf="hasProcedureLogEnabled" [disabled]="procedureLogConfigList?.length === 0"
        [ngClass]="{'activity-create-pending': isCreatingActivity('surgeryorder')}">
        <span class="message-label" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('surgeryorder')">{{'NEW_ACTIVITY_PROCEDURE_LOG' | translate}}</span>
        <div class="category-select-wrapper" (click)="$event.stopPropagation()">
          <ion-select
            interface="popover"
            placeholder="{{'SELECT_CATEGORY' | translate}}"
            toggleIcon="chevron-down" expandedIcon="chevron-up"
            [(ngModel)]="procedureCategory"
            (ionChange)="onProcedureCategoryChange($event.detail.value)"
            class="category-select-bordered">
            <ion-select-option *ngFor="let item of procedureLogConfigList; trackBy: trackByIndex" [value]="item.value" [disabled]="item.value === 'procedure_tracker' && device.isOffline">
              {{ item.label }}
            </ion-select-option>
          </ion-select>
        </div>
        <div class="right-group" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('surgeryorder')">
          <ion-spinner *ngIf="isCreatingActivity('surgeryorder')" name="crescent" class="create-spinner"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('surgeryorder')" class="arrow-icon" name="chevron-forward-outline" slot="end" [ngClass]="{'disabled': procedureCategory === 'procedure_tracker' && device.isOffline}"></ion-icon>
        </div>
      </ion-item>

      <ion-item class="item-with-category-select" *ngIf="isMeetingEnabled"
        [disabled]="activityCreationInProgress"
        [ngClass]="{'activity-create-pending': isCreatingActivity('meeting') && uiService.activeViewNewMeetingType !== 'live'}">
        <span class="message-label" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('meeting')">{{'MEETING' | translate}}</span>
        <div class="category-select-wrapper" *ngIf="meetingActivityTypes?.length > 0" (click)="$event.stopPropagation()">
          <button type="button" class="category-select-bordered meeting-format-trigger" (click)="openMeetingFormatPopover($event)">
            <span class="meeting-format-trigger-label">
              {{ selectedMeetingActivityType
                ? localizationService.getTranslatedString(selectedMeetingActivityType.indskr_name, activityTypeTranslationEntity)
                : ('SELECT_FORMAT' | translate) }}
            </span>
            <ion-icon name="chevron-down"></ion-icon>
          </button>
        </div>
        <div class="right-group" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('meeting')">
          <ion-spinner *ngIf="isCreatingActivity('meeting') && uiService.activeViewNewMeetingType !== 'live'" name="crescent" class="create-spinner"></ion-spinner>
          <ion-button *ngIf="hasVoiceNoteTakerEnabled && !isCreatingActivity('meeting')" fill="clear" class="voice-note-mic-button"
                      [disabled]="isMeetingFormatRequired && !selectedMeetingActivityType"
                      (click)="$event.stopPropagation(); $event.preventDefault(); openVoiceNoteCapture()">
            <ion-icon slot="icon-only" name="mic-outline"></ion-icon>
          </ion-button>
          <ion-icon class="arrow-icon" name="chevron-forward-outline" slot="end"
                    *ngIf="!(isCreatingActivity('meeting') && uiService.activeViewNewMeetingType !== 'live')"
                    [ngClass]="{'disabled': isMeetingFormatRequired && !selectedMeetingActivityType}"></ion-icon>
        </div>
      </ion-item>

      <ion-item *ngIf="hasTimeoffEnabled" (click)="setActiveView('timeoff')"
        [ngClass]="{'activity-create-pending': isCreatingActivity('timeoff')}">
        {{'TIME_OFF' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('timeoff')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('timeoff')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="item-with-category-select" *ngIf="isFollowUpActionEnabled" [disabled]="getFollowUpActionCategories()?.length === 0"
        [ngClass]="{'activity-create-pending': isCreatingActivity('follow-up-action')}">
        <span class="message-label" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('follow-up-action')">{{'FOLLOW_UP_ACTION' | translate}}</span>
        <div class="category-select-wrapper" (click)="$event.stopPropagation()">
          <ion-select
            interface="popover"
            placeholder="{{'SELECT_CATEGORY' | translate}}"
            toggleIcon="chevron-down" expandedIcon="chevron-up"
            [(ngModel)]="followUpActionCategory"
            (ionChange)="onFollowUpActionCategoryChange($event.detail.value)"
            class="category-select-bordered">
            <ion-select-option *ngFor="let category of getFollowUpActionCategories(); trackBy: trackByIndex" [value]="category.value">
              {{ category.label | translate }}
            </ion-select-option>
          </ion-select>
        </div>
        <div class="right-group" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('follow-up-action')">
          <ion-spinner *ngIf="isCreatingActivity('follow-up-action')" name="crescent" class="create-spinner"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('follow-up-action')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
        </div>
      </ion-item>

      <ion-item *ngIf="hasPhonecallEnabled" (click)="setActiveView('phonecall')"
        [ngClass]="{'greyedOut':noPhoneNumber, 'activity-create-pending': isCreatingActivity('phonecall')}">
        {{'NEW_ACTIVITY_PHONECALL' | translate }}
          <ion-spinner *ngIf="isCreatingActivity('phonecall')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('phonecall')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

        <ion-item class="item-with-category-select" *ngIf="hasDirectMessagingEnabled" [disabled]="filteredChannelList?.length === 0 || isMessageAMANoContact"
          [ngClass]="{'activity-create-pending': isCreatingActivity('email')}">
          <span class="message-label" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('email')">{{'MESSAGE' | translate}}</span>
          <div class="category-select-wrapper" (click)="$event.stopPropagation()">
            <ion-select
              interface="popover"
              [disabled]="isMessageAMANoContact"
              placeholder="{{'SELECT' | translate}} {{'NEW_ACTIVITY_CHANNEL' | translate}}"
              toggleIcon="chevron-down" expandedIcon="chevron-up"
              [(ngModel)]="selectedMessagingChannelType"
              (ionChange)="onChannelChange($event.detail.value)"
              class="category-select-bordered">
              <ion-select-option *ngFor="let channel of filteredChannelList; trackBy: trackByIndex" [value]="channel">
                {{ channelNameTranslation(channel.title) | translate }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="right-group" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('email')">
            <ion-spinner *ngIf="isCreatingActivity('email')" name="crescent" class="create-spinner"></ion-spinner>
            <ion-icon *ngIf="!isCreatingActivity('email')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
          </div>
        </ion-item>
        <!-- OMNI-61541: AMA No-Contact — secondary info sits below the row (sibling of ion-item, like Customer Inquiry) so it is full-width and not dimmed by the disabled row -->
        <div *ngIf="hasDirectMessagingEnabled && isMessageAMANoContact" class="cus-inq-desc activity-description ion-text-wrap ama-no-contact-desc">{{'AMA_NO_CONTACT_CANNOT_BE_MESSAGED' | translate}}</div>

      <ion-item (click)="setActiveView('consent')" *ngIf="isConsentCreationEnabled"
        data-testid="new-activity-consent"
        [ngClass]="{'activity-create-pending': isCreatingActivity('consent')}">
        {{'CONSENT' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('consent')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('consent')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="isAccountVisitEnabled" (click)="setActiveView('accountVisit')"
        [ngClass]="{'activity-create-pending': isCreatingActivity('accountVisit')}">
        {{'ACCOUNT_VISIT' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('accountVisit')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('accountVisit')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item (click)="setActiveView('order')" *ngIf="isOrderCreationEnabled"
        [ngClass]="{'activity-create-pending': isCreatingActivity('order')}">
        {{'NEW_ACTIVITY_SALES_ORDER' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('order')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('order')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasSamplingEnabled" (click)="setActiveView('allocation')"
        [ngClass]="{'greyedOut': noEligibleAllocation, 'activity-create-pending': isCreatingActivity('allocation')}">
        {{'ALLOWCATION_ORDER' | translate}}
        <ion-spinner *ngIf="isCreatingActivity('allocation')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
        <ion-icon *ngIf="!isCreatingActivity('allocation')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasSampleDeliveryRequestEnabled"
        (click)="createNewSampleDeliveryRequest()"
        [disabled]="activityCreationInProgress">
        {{'SAMPLE_DELIVERY_REQUEST' | translate}}
        <ion-icon class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item class="item-with-category-select" *ngIf="hasCustomerInquiryEnabled" [disabled]="caseManagementService.caseTypeList?.length === 0"
        [ngClass]="{'no-category-selected': !type, 'activity-create-pending': isCreatingActivity('customerinquiry')}">
        <span (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('customerinquiry')">{{translatedCustomerInquiryText}}</span>
        <div class="category-select-wrapper" (click)="$event.stopPropagation()">
          <ion-select 
            interface="popover"
            placeholder="{{'SELECT_CATEGORY' | translate}}" 
            toggleIcon="chevron-down" expandedIcon="chevron-up"
            [(ngModel)]="type" 
            (ionChange)="selectCaseType($event.detail.value)" 
            class="category-select-bordered">
            <ion-select-option *ngFor="let item of caseManagementService.caseTypeList; trackBy: trackByIndex" [value]="item">
              {{ item.name }}
            </ion-select-option>
          </ion-select>
        </div>
        <div class="right-group" (click)="$event.stopPropagation(); $event.preventDefault(); setActiveView('customerinquiry')">
          <ion-spinner *ngIf="isCreatingActivity('customerinquiry')" name="crescent" class="create-spinner"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('customerinquiry')" class="arrow-icon" name="chevron-forward-outline" slot="end" disabled="!type"></ion-icon>
        </div>
      </ion-item>
        <div *ngIf="hasCustomerInquiryEnabled && customerInquiryDescription" class='cus-inq-desc activity-description ion-text-wrap'
          [innerHTML]="customerInquiryDescription | transformLinkableText" (click)="openUrl($event, customerInquiryDescription); $event.stopPropagation()">
        </div>
        <div *ngIf="hasCustomerInquiryEnabled && type && type.description" class='cus-inq-desc activity-description ion-text-wrap'
          [innerHTML]="type.description | transformLinkableText" (click)="openUrl($event, type.description); $event.stopPropagation()">
        </div>

      <ion-item (click)="setActiveView('medicalinquiry')" *ngIf="hasMedicalInquiryEnabled"
        [ngClass]="{'activity-create-pending': isCreatingActivity('medicalinquiry')}">
        {{'MEDICAL_INQUIRY' | translate}}
        <ion-spinner *ngIf="isCreatingActivity('medicalinquiry')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
        <ion-icon *ngIf="!isCreatingActivity('medicalinquiry')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item (click)="setActiveView('meeting', 'live')" *ngIf="hasLiveMeetEnabled"
        [disabled]="activityCreationInProgress"
        [ngClass]="{'activity-create-pending': isCreatingActivity('meeting', 'live')}">
        {{'LIVE_MEETING' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('meeting', 'live')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('meeting', 'live')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasKitBookingEnabled" [ngClass]="{'greyedOut': device.isOffline, 'activity-create-pending': isCreatingActivity('kit_booking')}"
        (click)="setActiveView('kit_booking')">
        {{'KIT_BOOKING' | translate }}
          <ion-spinner *ngIf="isCreatingActivity('kit_booking')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('kit_booking')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasXperincesEnabled" (click)="setActiveView('new-insight')"
        [ngClass]="{'greyedOut': device.isOffline, 'activity-create-pending': isCreatingActivity('new-insight')}">
        {{NewActivitySource === 'Agenda' ? ('XPERIENCES_INSIGHTS_PLUS' | translate) : translatedCustomerInsightPlsText
        }}
          <ion-spinner *ngIf="isCreatingActivity('new-insight')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('new-insight')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasOpportunityEnabled" (click)="setActiveView('opportunity')"
        [ngClass]="{'greyedOut': hasOpportunityDisabledOffline, 'activity-create-pending': isCreatingActivity('opportunity') }">
        {{'OPPORTUNITY' | translate }}    
          <ion-spinner *ngIf="isCreatingActivity('opportunity')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('opportunity')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="isSurveyEnabled" (click)="setActiveView('survey')"
        [ngClass]="{'activity-create-pending': isCreatingActivity('survey')}">
        {{'SURVEY' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('survey')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('survey')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item (click)="setActiveView('quote')" *ngIf="isQuoteCreationEnabled"
        [ngClass]="{'activity-create-pending': isCreatingActivity('quote')}">
        Quote
          <ion-spinner *ngIf="isCreatingActivity('quote')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('quote')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasStoreCheckEnabled" (click)="setActiveView('storecheck')"
        [ngClass]="{'greyedOut':this.device.isOffline, 'activity-create-pending': isCreatingActivity('storecheck')}">
        {{'STORE_CHECK' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('storecheck')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('storecheck')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>

      <ion-item *ngIf="hasQuoteEnabled" (click)="setActiveView('quotes')"
        [ngClass]="{'greyedOut':this.device.isOffline, 'activity-create-pending': isCreatingActivity('quotes')}">
        {{'QUOTES' | translate}}
          <ion-spinner *ngIf="isCreatingActivity('quotes')" name="crescent" class="create-spinner" slot="end"></ion-spinner>
          <ion-icon *ngIf="!isCreatingActivity('quotes')" class="arrow-icon" name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
    </ion-item-group>

  <div class="sectionsList section-newTimeOff hideSection">
    <new-time-off #timeOffCmp [displayConflictAlert]="displayConflictAlert" [uuid]="uuid"></new-time-off>
  </div>
  </ion-list>
</ion-content>
<footer-toolbar [footerView]="'detailView'" [selectedView]="'newActivity'" hidden></footer-toolbar>
<io-spinner [displayText]="'NEW_ACTIVITY_SPINNER' | translate" *ngIf="isLoaderOn"></io-spinner>